import React from "react";

import { Tooltip, TooltipProps } from "@mui/material";

export const DefaultTooltip: React.FC<TooltipProps> = ({ children, ...props }) => {
  return (
    <Tooltip placement="top" {...props}>
      {children}
    </Tooltip>
  );
};
